// SchrankVerwaltungPage - Mitarbeiter-Zuweisungen verwalten
// Wie Ansicht, aber Klick auf Schrank öffnet Assignment-Dialog
import React, { useEffect, useState } from 'react';
import { Lock, Settings, AlertTriangle } from 'lucide-react';
import { schrankApi } from '../lib/api';
import MainLayout from '../components/layout/MainLayout';
import { Badge } from '../components/ui/badge';
import { Card, CardContent } from '../components/ui/card';
import { Skeleton } from '../components/ui/skeleton';
import { SchrankViewer } from '../components/schrank/SchrankViewer';

export function SchrankVerwaltungPage() {
  const [permissions, setPermissions] = useState(null);

  useEffect(() => {
    schrankApi.getMyPermissions().then((res) => setPermissions(res.data))
      .catch(() => setPermissions({ can_edit_grundriss: false, can_manage_zuweisung: false }));
  }, []);

  if (!permissions) {
    return <MainLayout><Skeleton className="h-96" /></MainLayout>;
  }

  if (!permissions.can_manage_zuweisung) {
    return (
      <MainLayout>
        <Card className="border-amber-300 bg-amber-50/60">
          <CardContent className="py-12 text-center space-y-3">
            <AlertTriangle className="w-10 h-10 text-amber-600 mx-auto" />
            <h2 className="font-semibold">Keine Berechtigung</h2>
            <p className="text-sm text-muted-foreground">
              Du benötigst die Zusatzberechtigung „Schränke verwalten“ oder eine entsprechende Rolle (Admin, Wachabteilungsleitung, Wachleitung).
            </p>
          </CardContent>
        </Card>
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <div className="space-y-4" data-testid="schrank-verwaltung-page">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
          <div>
            <h1 className="text-2xl sm:text-3xl font-heading font-bold flex items-center gap-2">
              <Lock className="w-7 h-7 text-primary" />
              Schrank-Verwaltung
            </h1>
            <p className="text-sm text-muted-foreground">
              Mitarbeiter und Abteilungen Schränken zuweisen. Klicke auf einen Schrank.
            </p>
          </div>
          <Badge variant="outline" className="text-blue-700 border-blue-400 bg-blue-50 w-fit">
            <Settings className="w-3 h-3 mr-1" /> Verwaltung
          </Badge>
        </div>
        <SchrankViewer mode="verwaltung" canAssign={true} />
      </div>
    </MainLayout>
  );
}

export default SchrankVerwaltungPage;
